// ONE status badge for the whole app. Master = the Sales Orders badge (.chip in shell.css: 11px / 600, 2px 8px, pill).
// tone: good | warn | crit | info | mut. `bg`/`color` override the tone for legacy status palettes (StatusBadge maps).
import React from 'react';

export default function Badge({ tone = 'mut', bg, color, className = '', style, children, ...rest }) {
  const sx = bg || color ? { background: bg, color, ...style } : style;
  return <span className={`chip ${bg || color ? '' : tone} ${className}`.trim()} style={sx} {...rest}>{children}</span>;
}
